export default __webpack_public_path__ + "static/HEYCUTIE_PINK-c51a7b493c30c81ba5160d10abd3bbc7.png";